// extracted by mini-css-extract-plugin
module.exports = {"confirmButtons":"FeedbackAssignmentModal_confirmButtons__2S92n"};